<template>
    <Header
        :page-title="title"
    ></Header>
    <div class="page-content">
        <informationNav
            :active-menu="'供求信息发布'"
            @navClick="handleNavClick"
        ></informationNav>
        <infoListCard
            :list-data="demandList"
            @infoListCardClick="handleCardClick0"
            @moreClick="handleMoreClick0"
        ></infoListCard>
        <infoListCard
            :list-data="serviceInfo"
            @infoListCardClick="handleCardClick1"
            @moreClick="handleMoreClick1"
        ></infoListCard>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import informationNav from "@/components/nav/informationNav"
import infoListCard from "@/components/card/infoListCard"
import { getDemandList } from "@/api/demand"
import { getServiceList } from '@/api/service'
// import { getPriceCompanyType } from "@/api/demand"
import { onMounted, reactive } from 'vue'
import { useRouter } from "vue-router"
const banner = require('@/assets/img/page_banner_1.png')
export default {
    name: "InformationService",
    setup() {
        const router = useRouter()
        const title = {
            cn: '供需发布',
            en: 'Information service',
            hasSearch: false,
            titleStyle: false,
            banner
        }
        const demandList = reactive({
            title: '需求信息',
            list: []
        })
        const serviceInfo = reactive({
            title: '服务信息',
            list: []
        })
        // let priceRes = reactive({})
        const getImg = (str) => {
            if (str) {
                return str.split(',')[0]
            }
        }
        // const getDomInfo = async () => {
        //     priceRes = await getPriceCompanyType()
        // }
        const getDemandData = async(size) => {
            const params = {
                "current": 1,
                "model": {
                    // "secondCategoryId": 100001,
                },
                "size": size,
            }
            const data = await getDemandList(params)
            demandList.list = data.records.map(k => ({
                title: k.title,
                address: k.address,
                createTime: k.createTime,
                effectiveTime: k.effectiveTime,
                // content: k.price,
                // size: priceRes[k.company],
                id: k.id,
                isTop: k.isTop,
                imgs: getImg(k.imgs)
            }))
            if (size >= 200) {
                router.push({ name: 'CardDetailList', query: {data: JSON.stringify(demandList)}})
            }
        }
        const getServiceData = async(size) => {
            const params = {
                "current": 1,
                "model": {
                    // "secondCategoryId": 100001,
                },
                "size": size,
            }
            const data = await getServiceList(params)
            serviceInfo.list = data.records.map(k => ({
                title: k.title,
                address: k.address,
                createTime: k.createTime,
                effectiveTime: k.effectiveTime,
                // content: k.price,
                // size: priceRes[k.company],
                id: k.id,
                isTop: k.isTop,
                imgs: getImg(k.imgs)
            }))
            // if (size >= 200) {
            //     router.push({ name: 'CardDetailList', query: {data: JSON.stringify(serviceInfo)}})
            // }
        }
        const handleMoreClick0 = () => {
            // getDemandData(200)
            const params = {title: '需求信息'}
            router.push({ name: 'CardDetailList', query: {data: JSON.stringify(params)}})
        }
        const handleMoreClick1 = () => {
            // 订单农业点击
            // getServiceData(200)
            const params = {title: '服务信息'}
            router.push({ name: 'CardDetailList', query: {data: JSON.stringify(params)}})
        }
        const handleNavClick = (name) => {
            if (name == '数字商城') {
                router.push({ name: 'Mall'})
            } else if (name == '供求信息发布') {
                router.push({ name: 'DemandInformationAdd'})
            } else if (name == '我的发布') {
                router.push({ name: 'EditInformation'})
            }
        }
        const handleCardClick0 = (id) => {
            router.push({ name: 'ALSDetails', query: {name: '需求信息', id: id}})
        }
        const handleCardClick1 = (id) => {
            // 订单农业点击
            router.push({ name: 'ALSDetails', query: {name: '服务信息', id: id}})
        }
        onMounted(() => {
            getDemandData(3)
            getServiceData(3)
            // getDomInfo()
        })
        return {
            title,
            demandList,
            serviceInfo,
            // priceRes,
            getDemandData,
            getServiceData,
            handleNavClick,
            getImg,
            // getDomInfo,
            handleCardClick0,
            handleCardClick1,
            handleMoreClick0,
            handleMoreClick1
        }
    },
    components: {
        Header,
        informationNav,
        infoListCard
    }
}
</script>

<style scoped>

</style>